<template>
  <p class="mt-2 text-sm leading-tight text-wt-gray-l">
    <slot />
  </p>
</template>
